<template>
  <b-modal centered hide-footer id="createCfContactModal" :title="`New ${modalTitle}`" @shown="focusMyElement">
    <ValidationObserver v-slot="{ invalid }" ref="form">
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>First Name</label>
            <b-form-input type="text" v-model="first_name" v-on:keyup.enter="saveContactFn" ref="focusThis"
              lazy-formatter :formatter="Format.titleCase" />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Last Name</label>
            <b-form-input type="text" v-model="last_name" v-on:keyup.enter="saveContactFn" lazy-formatter
              :formatter="Format.titleCase" />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Title</label>
            <b-form-input type="text" v-model="position" v-on:keyup.enter="saveContactFn" lazy-formatter
              :formatter="Format.titleCase" />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>{{ deliverableContactCompanyLabel(deliverableDetail.deliverable_template_id) }}</label>
            <b-form-input type="text" v-model="company_name" v-on:keyup.enter="saveContactFn" lazy-formatter
              :formatter="Format.titleCase" />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Email</label>
            <b-form-input type="email" v-model="email_address" v-on:keyup.enter="saveContactFn" lazy-formatter
              :formatter="Format.email" />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Phone</label>
            <b-form-input type="text" v-model="phone" v-on:keyup.enter="saveContactFn" lazy-formatter
              :formatter="Format.phone" />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Region</label>
            <multiselect v-model="region" :options="allRegions" :multiple="false"></multiselect>
          </div>
        </div>

        <div class="col-md-6" v-for="(obj, index) in cfChildren" :key="index">
          <div class="form-group">
            <label>{{ obj.label }}</label>
            <multiselect v-if="obj.field_type == 'select'" v-model="selectedValues[obj.field_key]"
              :options="getOptions(obj.value_set)" :multiple="!!obj.is_multiple" label="name" track-by="slug"
              :show-labels="false" :allow-empty="false" :close-on-select="true" @select="selectRole">
            </multiselect>
          </div>
        </div>

        <div class="col-md-12">
          <div class="form-group">
            <button class="btn btn-primary" type="button" @click="saveContactFn" data-dismiss="modal">Add</button>
          </div>
        </div>
        <div class="row" v-show="showErrorAlert">
          <div class="col">
            <b-alert v-model="showErrorAlert" variant="danger">There is a problem with the information entered
              above.</b-alert>
          </div>
        </div>
      </div>

    </ValidationObserver>
  </b-modal>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Format from "../../utility/Format";

export default {
  data() {
    return {
      modalTitle: "",
      cfChildren: [],
      first_name: "",
      last_name: "",
      email_address: "",
      company_name: "",
      position: "",
      phone: "",
      region: "Local",
      showErrorAlert: false,
      selectedValues: {},
      Format,
    };
  },
  computed: {
    ...mapGetters([
      "allRegions",
      "deliverableDetail",
      "deliverableContactsLabel",
      "deliverableContactCompanyLabel",
      "currentFieldKey",
      "currentContactTemplateType",
      "newContactName",
      "deliverableId",
      "projectDetail",
    ]),
    ...mapState({
      currentContactId: state => state.currentContactId,
      currentContactData: state => state.currentContactData,
    }),
  },
  methods: {
    resetFields() {
      this.first_name = "";
      this.last_name = "";
      this.email_address = "";
      this.company_name = "";
      this.position = "";
      this.phone = "";
      this.region = "Local";
      this.selectedValues = {};
      this.modalTitle = "";
      this.cfChildren = [];
    },
    focusMyElement() {
      // Set default name/role whenever modal opens
      this.resetFields();
      this.fillNameFields(this.newContactName);
      this.setModalTitle(this.currentFieldKey);
      this.$refs.focusThis.focus();
    },
    selectRole(selectedOption, id) {
      this.$set(this.selectedValues, "main_participants_role", selectedOption);
    },
    saveContactFn() {
      let first_name = this.first_name,
        last_name = this.last_name,
        email_address = this.email_address,
        phone = this.phone,
        company_name = this.company_name,
        region = this.region,
        position = this.position,
        deliverableId = this.deliverableId,
        currentFieldKey = this.currentFieldKey,
        contactFieldChildren = this.selectedValues,
        projectId = this.projectDetail.projectId,
        currentContactTemplateType = this.currentContactTemplateType
        ;
      let action = "createCfContact";
      if (currentContactTemplateType == "project") {
        action = "createProjectCfContact";
      }
      this.$store.dispatch(action, {
        first_name,
        last_name,
        email_address,
        phone,
        company_name,
        deliverableId,
        projectId,
        region,
        position,
        currentFieldKey,
        contactFieldChildren,
        currentContactTemplateType,
      });
      this.$bvModal.hide("createCfContactModal");
    },
    getOptions(valueSet) {
      let parsed = this.parseValue(valueSet);
      if (parsed == false) {
        return [];  // if we don't check for false... it thows up errors
      } else {
        // build value and text
        return parsed;
      }
    },
    parseValue(str) {
      try {
        return JSON.parse(str);
      } catch (e) {
        return false;
      }
    },
    fillNameFields(newContactName) {
      if (newContactName) {
        let namePieces = newContactName.split(" ");
        if (namePieces.length > 1) {
          this.last_name = Format.name(namePieces[namePieces.length - 1]);
          namePieces.pop();
        }
        this.first_name = Format.name(namePieces.join(" "));
      } else {
        this.first_name = "";
        this.last_name = "";
      }
    },
    setModalTitle(currentFieldKey) {
      if (currentFieldKey) {
        let templateCustomFields = this.deliverableDetail.templateCustomFields;
        if (this.currentContactTemplateType == "project") {
          templateCustomFields = this.projectDetail.projectCustomFields;
        }
        const objectWithFieldKey = templateCustomFields.find(obj => {
          return obj.field_key === currentFieldKey;
        });
        this.modalTitle = objectWithFieldKey.label;
        if (objectWithFieldKey.children) {
          this.cfChildren = objectWithFieldKey.children;
          objectWithFieldKey.children.forEach(child => {
            if (child.properties_set && child.field_type == "select") {
              // Set default value for multiselect from DB
              const parsed = this.parseValue(child.properties_set);
              this.$set(this.selectedValues, child.field_key, parsed.default);
            }
          });
        } else {
          //Reset selectedValues, so not passed in API
          this.selectedValues = {};
        }
      }
    },
  },
};
</script>

<style></style>